import { defaultConfig } from "@formkit/vue";
import { rootClasses } from "./formkit.theme.js";
import { genesisIcons } from "@formkit/icons";

export default defaultConfig({
    icons: {
        ...genesisIcons,
    },
    config: {
        rootClasses,
    },
});
